module.exports = __webpack_public_path__ + "img/cover4.52a75b4e.png";